export default "__VITE_ASSET__6df4565e__"